import React, { useState } from 'react';
import { Form, Row, Col, Button } from 'react-bootstrap';
import { debounce } from 'lodash';
import './FilterPanel.css';

const FilterPanel = ({ filters, setFilters, onReset }) => {
    const [localFilters, setLocalFilters] = useState(filters);
    const [dateMatchMode, setDateMatchMode] = useState('flexible');

    const debouncedSetFilters = debounce((newFilters) => {
        setFilters(newFilters);
    }, 500);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const newFilters = {
            ...localFilters,
            [name]: value
        };
        setLocalFilters(newFilters);
        
        // Validate price range immediately when either price field changes
        // if (name === 'minPrice' || name === 'maxPrice') {
        //     validatePriceRange(newFilters);
        // }

        // Validate dates immediately
        if (name === 'startDate' || name === 'endDate') {
            validateDateRange(newFilters);
        }
        
        debouncedSetFilters(newFilters);
    };

    const validatePriceRange = (filters) => {
        const { minPrice, maxPrice } = filters;
        // Only validate if both fields have complete values
        if (minPrice && maxPrice && 
            maxPrice.length >= minPrice.length && // Ensure max price input is complete
            parseFloat(minPrice) > parseFloat(maxPrice)) {
            // alert('Minimum price cannot be greater than maximum price');
            setLocalFilters(prev => ({
                ...prev,
                maxPrice: ''
            }));
        }
    };

    const validateDateRange = (filters) => {
        const { startDate, endDate } = filters;
        // Only validate if both dates have been explicitly selected
        if (startDate && endDate && startDate.trim() !== '' && endDate.trim() !== '') {
            if (new Date(startDate) > new Date(endDate)) {
                alert('Start date cannot be after end date');
                setLocalFilters(prev => ({
                    ...prev,
                    endDate: ''
                }));
            }
        }
    };

    const handleReset = () => {
        const emptyFilters = {
            city: '',
            address: '',
            minPrice: '',
            maxPrice: '',
            startDate: '',
            endDate: '',
            preferences: ''
        };
        setLocalFilters(emptyFilters);
        onReset();
    };

    return (
        <div className="filter-panel">
            <h5 className="filter-title">Filter Listings</h5>
            <Form>
                <Row className="mb-3">
                    <Col md={4}>
                        <Form.Group>
                            <Form.Label>City</Form.Label>
                            <Form.Select 
                                name="city" 
                                value={localFilters.city} 
                                onChange={handleChange}
                            >
                                <option value="">All Cities</option>
                                <option value="Champaign">Champaign</option>
                                <option value="Urbana">Urbana</option>
                                <option value="Savoy">Savoy</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col md={4}>
                        <Form.Group>
                            <Form.Label>Search Address</Form.Label>
                            <Form.Control
                                type="text"
                                name="address"
                                value={localFilters.address}
                                onChange={handleChange}
                                placeholder="Enter address..."
                            />
                        </Form.Group>
                    </Col>

                    <Col md={4}>
                        <Form.Group>
                            <Form.Label>Price Range</Form.Label>
                            <div className="d-flex gap-2">
                                <Form.Control
                                    type="number"
                                    name="minPrice"
                                    value={localFilters.minPrice}
                                    onChange={handleChange}
                                    placeholder="Min $"
                                />
                                <Form.Control
                                    type="number"
                                    name="maxPrice"
                                    value={localFilters.maxPrice}
                                    onChange={handleChange}
                                    placeholder="Max $"
                                />
                            </div>
                        </Form.Group>
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col md={4}>
                        <Form.Group>
                            <Form.Label>Preferences</Form.Label>
                            <Form.Select
                                name="preferences"
                                value={localFilters.preferences}
                                onChange={handleChange}
                            >
                                <option value="">Any</option>
                                <option value="Only Males">Males Only</option>
                                <option value="Only Females">Females Only</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>

                    <Col md={8}>
                        <Form.Group>
                            <Form.Label className="d-flex justify-content-between align-items-center">
                                Date Range
                                <Form.Check
                                    type="switch"
                                    id="date-mode-switch"
                                    label={dateMatchMode === 'exact' ? '📅 Exact' : '📅 Flexible'}
                                    checked={dateMatchMode === 'exact'}
                                    onChange={(e) => setDateMatchMode(e.target.checked ? 'exact' : 'flexible')}
                                />
                            </Form.Label>
                            <div className="d-flex gap-2">
                                <Form.Control
                                    type="date"
                                    name="startDate"
                                    value={localFilters.startDate}
                                    onChange={handleChange}
                                />
                                <Form.Control
                                    type="date"
                                    name="endDate"
                                    value={localFilters.endDate}
                                    onChange={handleChange}
                                />
                            </div>
                        </Form.Group>
                    </Col>
                </Row>

                <div className="d-flex justify-content-end">
                    <Button 
                        variant="secondary" 
                        onClick={handleReset}
                        size="sm"
                    >
                        Reset Filters
                    </Button>
                </div>
            </Form>
        </div>
    );
};

export default FilterPanel; 